module.exports = __webpack_public_path__ + "img/ClickForSound_34.722c75f7.png";